import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import {
    PanelBody, Button, PanelRow, TimePicker,
    __experimentalToggleGroupControl as ToggleGroupControl, 
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';
import {MediaPlaceholder, URLInput,MediaUpload } from '@wordpress/block-editor';
import { GoVideo } from "react-icons/go";
import { FaFileVideo, FaYoutube, FaVimeoV } from "react-icons/fa";
import {HeightControl, VayuBlocksAspectRatio, VayuBlocksToggleControl, VayuBlocksDropShadow, 
        VayuBlocksAnimation, VayuBlocksBackground, VayuBlocksDuotone, VayuBlocksAlignment} from '@vayu-blocks';

const SlideSettings = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const [openmedia, setopenmedia] = useState(false);

    const onSelectMedia = (media) => {
        setAttributes({ videoUrl: media.url,  });
    };

    const vayu_blocks_u_tube_video_change = (url) => {
        // Decode the URL to handle encoded characters like &amp;
        const decodedUrl = decodeURIComponent(url);
    
        // Regex for different types of YouTube URLs
        const youtubeRegexShortened = /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([\w-]{11})(?:\?si=[\w-]+)?/;
        const youtubeRegexStandard = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:watch\?v=|embed\/)([\w-]{11})(?:[^\s]*)?(?:&start=(\d+))?/;
        const iframeRegex = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([\w-]{11})\?[^&]*&start=(\d+)/;
        const youtubeRegexShorts = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([\w-]{11})(?:\?si=[\w-]+)?/;
    
        let match, videoId, startTime = null;
    
        // Check for shortened URL (youtu.be)
        match = decodedUrl.match(youtubeRegexShortened);
        if (match) {

            videoId = match[1];

            const startMatch = decodedUrl.match(/t=(\d+)/);
            startTime = startMatch ? startMatch[1] : null; // Extract the start time if present

            if (decodedUrl.match(youtubeRegexShorts)) {
                setAttributes({
                    videowidth: {
                        Desktop: '266px',
                        Tablet: '266px',
                        Mobile: '266px'
                    },
                    videoheight: {
                        Desktop: '473px',
                        Tablet: '473px',
                        Mobile: '473px'
                    },
                    youtubeshorts: true,
                    imageaspectratio:{
                        Desktop: "9/16",
                        Mobile:"9/16",
                        Tablet: "9/16"
                    }
                });
            } else {
                setAttributes({
                    videoheight: {
                        Desktop: '315px',
                        Tablet: '315px',
                        Mobile: '315px'
                    },
                    videowidth: {
                        Desktop: '560px',
                        Tablet: '560px',
                        Mobile: '560px'
                    },
                    youtubeshorts: false,
                    imageaspectratio:{
                        Desktop: "16/9",
                        Mobile:"16/9",
                        Tablet: "16/9"
                    }
                });
            }
            

        } else {
            // Check for standard YouTube URL, iframe URL, or Shorts URL
            match = decodedUrl.match(youtubeRegexStandard) || decodedUrl.match(iframeRegex) || decodedUrl.match(youtubeRegexShorts);
            if (match) {
                videoId = match[1];
                // Extract start time if it's present in the URL
                const startMatch = decodedUrl.match(/start=(\d+)/);
                startTime = startMatch ? startMatch[1] : null; // Extract the start time if present

                if (decodedUrl.match(youtubeRegexShorts)) {
                    setAttributes({
                        videowidth: {
                            Desktop: '266px',
                            Tablet: '266px',
                            Mobile: '266px'
                        },
                        videoheight: {
                            Desktop: '473px',
                            Tablet: '473px',
                            Mobile: '473px'
                        },
                        youtubeshorts: true,
                        imageaspectratio:{
                            Desktop: "9/16",
                            Mobile:"9/16",
                            Tablet: "9/16"
                        }
                    });
                } else {
                    setAttributes({
                        videoheight: {
                            Desktop: '315px',
                            Tablet: '315px',
                            Mobile: '315px'
                        },
                        videowidth: {
                            Desktop: '560px',
                            Tablet: '560px',
                            Mobile: '560px'
                        },
                        youtubeshorts: false,
                        imageaspectratio:{
                            Desktop: "16/9",
                            Mobile:"16/9",
                            Tablet: "16/9"
                        }
                    });
                }
                
            } else {
                // If no valid match is found, clear the video URL and start time
                setAttributes({ youvideoUrl: '', startTime: '',
                    imageaspectratio:{
                        Desktop: "",
                        Mobile:"",
                        Tablet: ""
                    }
                 });
               
                return;
            }
        }
 
        if (startTime !== null) {
            startTime = Number(startTime); // Ensure startTime is a number
        }

        // Save videoId and startTime if valid
        setAttributes({
            youvideoUrl: videoId,
            startTime: startTime
        });
    };

    const vayu_blcks_u_tube_url = () => {
        if (attributes.youvideoUrl) {
            const videoId = attributes.youvideoUrl;
            return `https://www.youtube.com/watch?v=${videoId}`; // Regular URL without start time
        }
        return ''; // Return empty if no video URL is available
    };

    const vayu_blcks_vimeo_url = () => {
        if (attributes.vimeourl) {
            return `https://player.vimeo.com/video/${attributes.vimeourl}`;
        }
        return '';
    };

    const vayu_blocks_vimeo_change = (url) => {
        const decodedUrl = decodeURIComponent(url.trim());
    
        // Match all valid Vimeo formats
        const vimeoRegex = /vimeo\.com\/(?:video\/)?(\d+)/;
    
        const match = decodedUrl.match(vimeoRegex);
    
        if (match && match[1]) {
            const videoId = match[1];
    
            setAttributes({
                vimeourl: videoId,
                imageaspectratio:{
                    Desktop: "",
                    Mobile:"",
                    Tablet: ""
                },
                videoheight: {
                    Desktop: '315px',
                    Tablet: '315px',
                    Mobile: '315px'
                },
                videowidth: {
                    Desktop: '560px',
                    Tablet: '560px',
                    Mobile: '560px'
                },
            });
      
        } else {
            // Invalid URL
            setAttributes({ vimeourl: '' });
 
        }
    };
    
    const vayu_blocks_start_time = () => {
        const totalSeconds = attributes.startTime; // assuming startTime is in seconds

        const minutes = Math.floor((totalSeconds % 3600) / 60); // get remaining minutes
        const seconds = totalSeconds % 60; // remaining seconds

        // Return an object with hours, minutes, and seconds

        return {
            hours: minutes,
            minutes: seconds
        };
    }

    const vayu_blocks_end_time = () => {
        const totalSeconds = attributes.endTime; // assuming startTime is in seconds

        const minutes = Math.floor((totalSeconds % 3600) / 60); // get remaining minutes
        const seconds = totalSeconds % 60; // remaining seconds

        // Return an object with hours, minutes, and seconds

        return {
            hours: minutes,
            minutes: seconds
        };
    }
    
    const vayu_blcoks_endtimechange = (value) => {
    
        // Ensure value is in the correct format
        if (value && value.hours !== undefined && value.minutes !== undefined) {
            const hours = value.hours??0;
            const minutes = value.minutes??0;
            
            // Convert to seconds
            const totalSeconds = (hours * 60) + (minutes);
            
            // Set the converted seconds as the start time
            setAttributes({ startTime: totalSeconds });
        } else {
            console.error("Invalid input format");
        }
    };   

    const vayu_blcoks_startimechange = (value) => {

        // Ensure value is in the correct format
        if (value && value.hours !== undefined && value.minutes !== undefined) {
            const hours = value.hours??0;
            const minutes = value.minutes??0;
            // Convert to seconds
            const totalSeconds = (hours * 60) + (minutes);

            // Set the converted seconds as the start time
            setAttributes({ endTime: totalSeconds });
        } else {
            console.error("Invalid input format");
        }
    };   

    const handlevideochange = (value) => {
        setAttributes({blockValue: value})

        if(value === 'you-tube'){
            if(attributes.youtubeshorts){
                setAttributes({ videowidth: {
                    Desktop: '266px',
                    Tablet: '266px',
                    Mobile: '266px'
                },
                videoheight: {
                    Desktop: '473px',
                    Tablet: '473px',
                    Mobile: '473px'
                },
                imageaspectratio:{
                    Desktop: "9/16",
                    Mobile:"9/16",
                    Tablet: "9/16"
                }})
        }else{
            setAttributes({
                videoheight: {
                    Desktop: '315px',
                    Tablet: '315px',
                    Mobile: '315px'
                },
                videowidth: {
                    Desktop: '560px',
                    Tablet: '560px',
                    Mobile: '560px'
                },
                imageaspectratio:{
                    Desktop: "16/9",
                    Mobile:"16/9",
                    Tablet: "16/9"
                }
            });
        }
        }

        if(value === 'mp4' || value==='vimeo'){
             setAttributes({
                imageaspectratio:{
                    Desktop: "16/9",
                    Mobile:"16/9",
                    Tablet: "16/9"
                }
            });
        }
    }
    
    const setmediaurl = (url) =>{
        setAttributes({ 
            videoUrl: url, 
            imageaspectratio:{
                Desktop: "",
                Mobile:"",
                Tablet: ""
            },
            videoheight: {
                Desktop: '315px',
                Tablet: '315px',
                Mobile: '315px'
            },
            videowidth: {
                Desktop: '560px',
                Tablet: '560px',
                Mobile: '560px'
            } 
        })
    };

    return (
        <div class="vb-video-ispector-video vb-video-ispector-video-main">

            <PanelBody 
                title={__('Video','vayu-blocks')}  
                opened={openPanels['slide-video']}
                onToggle={() => onTogglePanel('slide-video')}
            >

                <div className="vb-video-variation vb-video-select-control-panel">
                        <span className="vb-video-variation-icon">
                            <GoVideo />
                            <span className="vb-video-variation-heading">Select Video Type</span>
                        </span>
            
                        <div className="vb-video-variation-child">
                        <div
                            className={`vb-video-variation-card ${attributes.blockValue === 'mp4' ? 'selected' : ''}`}
                            onClick={() => handlevideochange('mp4')}
                        >
                            <FaFileVideo size={28} />
                            <span>MP4</span>
                        </div>

                        <div
                            className={`vb-video-variation-card ${attributes.blockValue === 'you-tube' ? 'selected' : ''}`}
                            onClick={() => handlevideochange('you-tube')}
                        >
                            <FaYoutube size={28} color="#FF0000" />
                            <span>YouTube</span>
                        </div>

                        <div
                            className={`vb-video-variation-card ${attributes.blockValue === 'vimeo' ? 'selected' : ''}`}
                            onClick={() => handlevideochange('vimeo')}
                        >
                            <FaVimeoV size={28} color="#1ab7ea" />
                            <span>Vimeo</span>
                        </div>
                        </div>

                </div>

                {attributes.blockValue==='mp4' && (
                    <>
                        <div className="vb-video-panel-upload">
                            
                            <MediaPlaceholder
                                icon={<GoVideo size={28} />}
                                className="vb-video-panel-media"
                                labels={{ title: 'Upload a video' }}
                                onSelect={onSelectMedia}
                                onSelectURL={(url) => setmediaurl(url)}
                                allowedTypes={['video']}
                                accept="video/*"
                                disableMediaButtons={!!attributes.videoUrl}
                            />
                        
                        </div>

                        {attributes.videoUrl && (
                            <>

                            <div className="vayu_blcoks_image_video">
                                <video  key={attributes.videoUrl} width="320" height="140" loop controls>
                                    <source src={attributes.videoUrl} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>

                                <div className="vb-video-update-button">
                                    <PanelRow>
                                        <Button
                                            isSmall
                                            isSecondary
                                            onClick={() => setAttributes({videoUrl:""})}
                                        >
                                            { __( 'Clear Video', 'vayu-blocks' ) }
                                        </Button>
                                    </PanelRow>

                                    <PanelRow className="vb-video-update-panelrow">
                                        <Button
                                            isSmall
                                            isSecondary
                                            onClick={() => setopenmedia(true)}
                                        >
                                            { __( 'Replace', 'vayu-blocks' ) }
                                        </Button>
                                    </PanelRow>

                                    <MediaUpload
                                        onSelect={onSelectMedia}
                                        allowedTypes={['video']}
                                        accept="video/*"
                                        value={attributes.videoUrl}
                                        render={({ open }) => {
                                            if (openmedia) {
                                                setopenmedia(false); 
                                                open(); 
                                            }
                                            return null;
                                        }}
                                    />

                                            
                                </div>
                            </div>

                                <br/>

                                <VayuBlocksBackground
                                        onChange={(key,value)=>setAttributes({[key]:value})}
                                    headingLabel="Thumbnail"
                                    colorPanel = {[
                                        {
                                            active: ['media'],
                                            label: 'Upload Image',
                                            key:'fallbackImageUrl',
                                            value:attributes.fallbackImageUrl
                                        }
                                    ]}
                                />

                                <VayuBlocksBackground
                                        onChange={(key,value)=>setAttributes({[key]:value})}
                                        colorPanel = {[
                                            {
                                                active: ['gradient'],
                                                label: 'Video Background',
                                                key:'videoboxcolor',
                                                value:attributes.videoboxcolor,
                                            }
                                        ]}
                                    />

                                <div className="vb-toggle-wrapper-video">

                                    <VayuBlocksToggleControl
                                        label={__('Playback Controls', 'vayu-blocks')}
                                        checked={attributes.controls}
                                        onChange={(value) => setAttributes({ controls: value })}
                                    />

                                    <VayuBlocksToggleControl
                                        label={__('Autoplay', 'vayu-blocks')}
                                        checked={attributes.autoplay}
                                        onChange={(value) => setAttributes({ autoplay: value })}
                                        help="Autoplay will only work in live."
                                    />


                                    <VayuBlocksToggleControl
                                        label={__('Loop', 'vayu-blocks')}
                                        checked={attributes.loop}
                                        onChange={(value) => setAttributes({ loop: value })}
                                    />

                                    {!attributes.autoplay && (

                                        <VayuBlocksToggleControl
                                            label={__('Muted', 'vayu-blocks')}
                                            checked={attributes.muted}
                                            onChange={(value) => setAttributes({ muted: value })}
                                        />
                                    
                                    )}

                                    {attributes.controls && (
                                        <>

                                            <VayuBlocksToggleControl
                                                label={__('Disable Fullscreen', 'vayu-blocks')}
                                                checked={attributes.nofullscreen}
                                                onChange={(value) => setAttributes({ nofullscreen: value })}
                                            />

                                            <VayuBlocksToggleControl
                                                label={__('Disable Download', 'vayu-blocks')}
                                                checked={attributes.nodownload}
                                                onChange={(value) => setAttributes({ nodownload: value })}
                                            />

                                            <VayuBlocksToggleControl
                                                label={__('Playback Controls', 'vayu-blocks')}
                                                checked={attributes.controls}
                                                onChange={(value) => setAttributes({ controls: value })}
                                            />

                                            <VayuBlocksToggleControl
                                                label={__('Disable Playback Rate', 'vayu-blocks')}
                                                checked={attributes.noplaybackrate}
                                                onChange={(value) => setAttributes({ noplaybackrate: value })}
                                            />
                                        </>
                                    )}

                                </div>

                            </>
                        )}

                    </>
                )}

                {attributes.blockValue==='you-tube' && (
                    <>
                        <div className="vayu_blocks_url_input">
                            <div className="vb-url-label-row">
                                <label>Enter YouTube URL</label>
                                <a
                                    href="https://www.youtube.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Go to YouTube"
                                >
                                    <FaYoutube size={20} />
                                </a>
                            </div>

                            <URLInput
                                value={vayu_blcks_u_tube_url()}
                                onChange={(url) => vayu_blocks_u_tube_video_change(url)}
                                placeholder="Enter YouTube URL"
                                className="vb-url-input"
                            />
                        </div>

                        {attributes.youvideoUrl && (
                            <>
                        <div className="vayu_blocks_image_video">
                            <iframe
                                width="236"
                                height="150"
                                src={`https://www.youtube.com/embed/${attributes.youvideoUrl}`}
                                title="YouTube video player"
                                frameborder="0"
                                referrerpolicy="strict-origin-when-cross-origin"
                            ></iframe>

                            <PanelRow>
                                    <Button
                                        isSmall
                                        isSecondary
                                        onClick={() => setAttributes({youvideoUrl:""})}
                                    >
                                        { __( 'Clear Video', 'vayu-blocks' ) }
                                    </Button>
                                </PanelRow></div>

                                <br/>

                                <VayuBlocksBackground
                                        onChange={(key,value)=>setAttributes({[key]:value})}
                                        colorPanel = {[
                                            {
                                                active: ['gradient'],
                                                label: 'Video Background',
                                                key:'videoboxcolor',
                                                value:attributes.videoboxcolor,
                                            }
                                        ]}
                                    />
                                
                                <div className="vb-toggle-wrapper-video">
                                    <div class="vayu-blcoks-timepicker-defined">
                                        <TimePicker.TimeInput 
                                            label={__('Start Time', 'vayu-blocks')}
                                            value={vayu_blocks_start_time()}
                                            onChange={(value)=> vayu_blcoks_endtimechange(value)}
                                        />

                                        <TimePicker.TimeInput 
                                            label={__('End Time', 'vayu-blocks')}
                                            value={vayu_blocks_end_time()}
                                            onChange={(value)=> vayu_blcoks_startimechange(value)}
                                        />
                                    </div>

                                    <VayuBlocksToggleControl
                                        label={__('Hide Controls', 'vayu-blocks')}
                                        checked={attributes.youcontrols }
                                        onChange={(value) => setAttributes({ youcontrols : value })}
                                    />

                                    <VayuBlocksToggleControl
                                        label={__('Autoplay', 'vayu-blocks')}
                                        checked={attributes.youautoplay}
                                        onChange={(value) => setAttributes({ youautoplay: value })}
                                    />
                                    
                                    <VayuBlocksToggleControl
                                        label={__('Loop', 'vayu-blocks')}
                                        checked={attributes.youloop}
                                        onChange={(value) => setAttributes({ youloop: value })}
                                    />

                                    <VayuBlocksToggleControl
                                        label={__('Allow Full Screen', 'vayu-blocks')}
                                        checked={attributes.youtubefullscreen}
                                        onChange={(value) => setAttributes({ youtubefullscreen: value })}
                                    />

                                    <VayuBlocksToggleControl
                                        label={__('Rel', 'vayu-blocks')}
                                        help="Related videos will only appear from the current channel."
                                        checked={attributes.rel}
                                        onChange={(value) => setAttributes({ rel: value })}
                                    />
                                </div>

                                </>
                        )}

                    </>
                )}

                {attributes.blockValue === 'vimeo' && (
                    <>

                        <div className="vayu_blocks_url_input">

                            <div className="vb-url-label-row">
                                <label>Enter Vimeo URL</label>
                                <a
                                    href="https://www.vimeo.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Go to Vimeo"
                                >
                                        <FaVimeoV size={20} color="#1ab7ea"/>
                                </a>
                            </div>

                            <URLInput
                                value={vayu_blcks_vimeo_url()}
                                onChange={(url) => vayu_blocks_vimeo_change(url)}
                                placeholder="Enter Vimeo URL"
                                className="vb-url-input"
                            />

                        </div>

                        {attributes.vimeourl && (
                            <>
                            
                                <div className="vayu_blocks_image_video">
                                    <iframe
                                        width="236"
                                        height="150"
                                        src={`https://player.vimeo.com/video/${attributes.vimeourl}?autoplay=1&muted=1&loop=1`}
                                        title="Vimeo video player"
                                        frameBorder="0"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allow="autoplay; fullscreen; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>

                                    <PanelRow>
                                        <Button
                                            isSmall
                                            isSecondary
                                            onClick={() => setAttributes({ vimeourl: "" })}
                                        >
                                            {__('Clear Video', 'vayu-blocks')}
                                        </Button>
                                    </PanelRow>
                                </div>

                                <br/>

                                    <VayuBlocksBackground
                                            onChange={(key,value)=>setAttributes({[key]:value})}
                                            colorPanel = {[
                                                {
                                                    active: ['gradient'],
                                                    label: 'Video Background',
                                                    key:'videoboxcolor',
                                                    value:attributes.videoboxcolor,
                                                }
                                            ]}
                                        />

                                <div className="vb-toggle-wrapper-video">

                                    <VayuBlocksToggleControl
                                        label={__('Autoplay', 'vayu-blocks')}
                                        checked={attributes.vimeoautoplay}
                                        onChange={(value) => setAttributes({ vimeoautoplay: value })}
                                    />
                                    
                                    {!attributes.vimeoautoplay && (
                                        <VayuBlocksToggleControl
                                            label={__('Muted', 'vayu-blocks')}
                                            checked={attributes.vimeomuted}
                                            onChange={(value) => setAttributes({ vimeomuted: value })}
                                        />
                                    )}
                                    
                                    <VayuBlocksToggleControl
                                        label={__('Loop', 'vayu-blocks')}
                                        checked={attributes.vimeoloop}
                                        onChange={(value) => setAttributes({ vimeoloop: value })}
                                    />

                                    <VayuBlocksToggleControl
                                        label={__('Show Controls', 'vayu-blocks')}
                                        checked={attributes.vimeocontrols}
                                        onChange={(value) => setAttributes({ vimeocontrols: value })}
                                    />


                                    <VayuBlocksToggleControl
                                        label={__('Allow Full Screen', 'vayu-blocks')}
                                        checked={attributes.vimeofullscreen}
                                        onChange={(value) => setAttributes({ vimeofullscreen: value })}
                                    />

                                    <VayuBlocksToggleControl
                                        label={__('Background Mode', 'vayu-blocks')}
                                        help={__('Enables background autoplay with no controls. Must be muted.', 'vayu-blocks')}
                                        checked={attributes.vimeobackground}
                                        onChange={(value) => setAttributes({ vimeobackground: value })}
                                    />
                                </div>

                            </>
                        )}

                    </>
                )}

                <br/>

                {((attributes.blockValue ==='vimeo' && attributes.vimeourl)|| (attributes.blockValue ==='mp4' && attributes.videoUrl) || (attributes.blockValue==='you-tube' &&  attributes.youvideoUrl ) ) && (
                    <>

                        <ToggleGroupControl
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            label={__('Size', 'vayu-blocks')}
                            isBlock
                            value={attributes.screenfit}
                            onChange={(value) => setAttributes({screenfit:value})}
                            >
                                
                            <ToggleGroupControlOption
                                label="Auto"
                                value="auto"
                            />
                            <ToggleGroupControlOption
                                label="Screen Fit"
                                value="screenfit"
                            />
                            <ToggleGroupControlOption
                                label="Custom"
                                value="custom"
                            />

                        </ToggleGroupControl>


                        {attributes.screenfit === 'auto' && (
                            <VayuBlocksAspectRatio
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                aspectRatio = {{key:'imageaspectratio', value:attributes.imageaspectratio}}
                            />
                        )}

                        {attributes.screenfit=== 'custom' && (
                            <>
                                <HeightControl
                                    label={__('Width', 'vayu-blocks')}
                                    value={ attributes.videowidth }
                                    onChange={ (value) => setAttributes({videowidth: value }) }
                                    responsive={true}
                                    unitMax={{
                                                px: { max: 3000, step: 1 },
                                            }}
                                    customUnits={['px','vh','vw', 'em', 'rem','dvw','svh','lvh', 'dvh', 'vi', 'svi', 'lvi', 'dvi', 'vb', 'svb',]}
                                />
                                
                                <HeightControl
                                    label={__('Height', 'vayu-blocks')}
                                    value={ attributes.videoheight }
                                    onChange={ (value) => setAttributes({videoheight: value }) }
                                    responsive={true}
                                />

                            </>
                        )}

                        <br/>

                        <VayuBlocksAlignment
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            alignment = {{key:'imagealignment',value:attributes.imagealignment}}
                        />
                        <br/>

                        <VayuBlocksDuotone
                            duotoneValue={attributes.duotone}
                            setAttributes={setAttributes}
                            key={'duotone'}
                        />

                        <VayuBlocksDropShadow 
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            dropShadow={{key:'imageboxShadow',value:attributes.imageboxShadow}}
                        />

                    
                    </>
                )}
                
            </PanelBody >
            
            <PanelBody 
                title={__('Advance Effect','vayu-blocks')}
                opened={openPanels['slide-effect']}
                onToggle={() => onTogglePanel('slide-effect')}
            >
            
                <VayuBlocksAnimation
                    animationData={attributes.animationData}
                    onChange={(key, value) => {setAttributes({ [key]: value });}}
                    dataKey="animationData"
                />

            </PanelBody>

        </div>
    );
};

export default SlideSettings;